import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const getUnpaidInvoices = createAsyncThunk(
  "AgentTabs/getUnpaidInvoices",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/users/v2/tabs/unpaid-invoice/${data.user_id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return resp.data.data;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response.data.message);
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
